import React, { useEffect, useState } from 'react'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import LogoFlagPreview from './LogoFlagPreview'
import { presets } from '../util/presets'
const AnimatedLogoPreview = () => {
  const [currentState, setCurrentState] = useState({
    icon: 'faStar',
    backgroundColor: '#ffffff',
    iconColor: '#000000',
    exactIconSize: 64,
    borderRadius: 8,
    borderWidth: 0,
    rotate: 0,
  })

  useEffect(() => {
    let currentIndex = 0
    const intervalId = setInterval(() => {
      // Smoothly transition to next state
      const nextState = presets[currentIndex]
      setCurrentState((prev) => ({
        ...prev,
        ...nextState,
      }))

      currentIndex = (currentIndex + 1) % presets.length
    }, 1800) // Even faster transitions

    return () => clearInterval(intervalId)
  }, [])

  return <LogoFlagPreview {...currentState} ratio={1} />
}

export default AnimatedLogoPreview
